import { FC, useState, useEffect } from 'react';
import { useTrans } from 'base/utils/i18n';
import { ReferralTitle } from 'mod/referral/ReferralTitle';
import site from 'pro/config/site';
import { BtnSendReferral } from 'mod/referral/BtnSendReferral';
import { Image, ThemeImageProps } from '@base/lib/ThemeImage';

type IReferralIntoProps = {
    className?: string;
    image: Partial<ThemeImageProps>;
};

export const ReferralInto: FC<IReferralIntoProps> = props => {
    const { className, image } = props;
    const { t } = useTrans();
    return (
        <div className={className}>
            <ReferralTitle>{t('web_referral_intro_title', { brand: site.brand })}</ReferralTitle>
            <div className="g-desc">{t('web_referral_intro_content', { brand: site.brand })}</div>
            <div className="g-btn-wrap">
                <BtnSendReferral trackPosition={1}/>
            </div>
            <Image
                className={'g-banner'}
                background={false}
                {...image}
            />
        </div>
    )
};
